import { UpsellGroup } from 'types/models/Menu/Upsell';
import { ChoiceGroup, PortionRatio } from './ChoiceGroup';

export type ProductPortions = Record<number, AztecPortion>;
export type DisplayRecords = Record<number, DisplayRecord>;
export type AztecProducts = Record<number, AztecProduct>;
export type AztecPortions = Record<number, AztecPortion>;

export interface DisplayRecord {
  alt_text?: string;
  calories?: number | null;
  choiceImage?: string;
  description: string;
  effectiveDate: string;
  expiryDate: string;
  id: number;
  image: string;
  keywords: number[];
  mayStock: number;
  name: string;
  showPrices: number;
}

export interface AztecChoice {
  choiceId: number;
  displayRecordId: number;
  portionId: number;
  choiceGroup: ChoiceGroup;
}

export interface AztecPortion {
  choices: AztecChoice[];
  id: number;
  name: string;
  portion_name: string;
  price: number;
  supplementPrice?: number;
  calories: number | null;
  description?: string;
  quantity?: number;
}

export interface AztecProduct {
  andedUpsells?: AztecProduct[];
  basketId?: string;
  categoryId: number;
  defaultCourseId: number;
  displayName: string;
  defaultPortionId: number;
  displayRecordId: number;
  displayRecords: DisplayRecords;
  divisionId: number;
  eposName: string;
  id: number;
  isInstruction?: boolean;
  isInvalid?: boolean;
  isOutOfStock?: boolean;
  menuId: number;
  minimumCustomerAge?: number;
  portions: AztecPortions;
  showCourseDialog: number;
  specialRequest?: string;
  subcategoryId: number;
  upsellGroup?: UpsellGroup;
}

export interface BreadcrumbTrack {
  choiceIndex: number;
  choiceGroupIndex: number;
  choiceName?: string;
  portionId: number;
  portionRatios: PortionRatio[];
}

export enum BreadcrumbDirection {
  Forward = 1,
  Backward = -1,
}
